import React from 'react';
import { connect } from 'react-redux';
import { Box, Grid, GridItem } from '@drone-js/core';
import { mapDispatchToProps, mapStateToProps, SearchPageContentProps } from 'component/page/search/SearchPageContent/SearchPageContent.selectors';
import ActivityList from 'component/page/search/ActivityList/ActivityList';
import ActivityCardPlaceHolder from 'component/common/ActivityCard/PlaceHolder/ActivityCardPlaceHolder';
import PageContainer from 'component/common/PageContainer/PageContainer';
import PaginationContainer from 'component/page/search/Pagination/PaginationContainer';
import SortAndFilterSidebar from 'component/page/search/SortAndFilter/Sidebar/SortAndFilterSidebar';
import SearchSupplyError from 'component/page/search/Error/SearchSupplyError';
import { GridSizeEnum } from 'core-framework/constant/GridSize';
import EarnBurnToggle from 'component/common/EarnBurnToggle/EarnBurnToggle';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';
import ContentContainer from 'component/common/ContentContainer/ContentContainer';
import { getCategoryItems } from 'component/page/search/SortAndFilter/Filter/filter.utils';
import { getSelectedTab } from 'component/page/search/Categories/categories.utils';
import { UnlockTripSavingsBanner } from 'component/page/search/UnlockTripSavingsBanner/UnlockTripSavingsBanner';
import SearchTitle from 'component/page/search/SearchTitle/SearchTitle';

const SearchPageContent: React.FC<SearchPageContentProps> = (props) => {
    const {
        behavior,
        loyaltySearchType,
        isInCitySearch,
        isSuccess,
        isPageContainerSpacing,
        isEmbedded,
        screenSize,
        config,
        filter,
        isLoading,
        isNoResults,
        embeddedFooter,
        searchPagePadding,
        setLoyaltySearchType,
    } = props;
    const isEarnEnabled = loyaltySearchType === LoyaltySearchType.EARN;
    const isDisplayInCitySearchContent = isInCitySearch && isSuccess;
    const marginX = isPageContainerSpacing ? undefined : isEmbedded ? 'auto' : '0';
    const paddingX = isPageContainerSpacing ? undefined : isEmbedded && screenSize.desktop ? '16' : '4';
    const maxWidth = isPageContainerSpacing ? 'none' : '1500px';
    const minHeight = isPageContainerSpacing ? 'none' : '71.4vh';

    const updateLoyaltySearchTypeFromEarnBurnToggle = (isEarn: boolean) => {
        const loyaltySearchTypeFromToggle = isEarn ? LoyaltySearchType.EARN : LoyaltySearchType.BURN;
        setLoyaltySearchType(loyaltySearchTypeFromToggle);
    };

    const categoryFilter = getCategoryItems(config.cms, filter.valueFilterMatrix, props.filterMatrix?.valueFilterMatrix);
    const selectedTab = getSelectedTab(categoryFilter);

    return (
        <PageContainer data-testid="activities-search-page" flex={1} overflowY="visible" pb={isEmbedded ? '0' : '48'}>
            <ContentContainer
                maxWidth={maxWidth}
                minHeight={minHeight}
                flex={1}
                enforceDefaultSpacing={!isEmbedded}
                isWithVerticalSpace={true}
                mx={marginX}
                px={paddingX}
                data-testid="activities-search-page-content"
                searchPagePadding={searchPagePadding}
            >
                <SearchTitle
                    isLoading={isLoading}
                    totalFilteredActivities={props.totalFilteredActivities}
                    isKeywordDisplayed={props.isKeywordDisplayed}
                    isDisplayInCitySearchContent={isDisplayInCitySearchContent}
                />
                <Grid fluid={true}>
                    {screenSize.desktop && (
                        <GridItem xl={GridSizeEnum.Two} lg={GridSizeEnum.Three}>
                            {behavior.common.showEarnBurnToggle && (
                                <Box mb="12">
                                    <EarnBurnToggle isEarn={isEarnEnabled} onToggleChange={updateLoyaltySearchTypeFromEarnBurnToggle} />
                                </Box>
                            )}
                            <SortAndFilterSidebar isLoading={isLoading} />
                        </GridItem>
                    )}
                    {!screenSize.desktop && behavior.common.showEarnBurnToggle && (
                        <GridItem xl={GridSizeEnum.Ten} lg={GridSizeEnum.Nine} md={GridSizeEnum.Twelve} sm={GridSizeEnum.Twelve}>
                            <Box mt={screenSize.mobile ? '12' : '0'}>
                                <EarnBurnToggle isEarn={isEarnEnabled} onToggleChange={updateLoyaltySearchTypeFromEarnBurnToggle} />
                            </Box>
                        </GridItem>
                    )}
                    <GridItem xl={GridSizeEnum.Ten} lg={GridSizeEnum.Nine} md={GridSizeEnum.Twelve} sm={GridSizeEnum.Twelve}>
                        {/* DON'T REMOVE: This div is to solve spacing issue when number of cards is not enough to fill the whole page */}
                        <div id={`categories-tabs-panel-${selectedTab + 1}`}>
                            <UnlockTripSavingsBanner
                                outerBoxProps={{
                                    pb: '12',
                                    backgroundColor: 'base.background',
                                }}
                                innerBoxProps={{
                                    pt: '2',
                                    m: '-2',
                                }}
                            />
                            <Grid spacing={screenSize.mobile ? '4' : '12'} fluid={true}>
                                {isLoading && <ActivityCardPlaceHolder />}
                                {isSuccess && <ActivityList />}
                                {isSuccess && !isEmbedded && <PaginationContainer />}
                                {!isLoading && isNoResults && <SearchSupplyError />}
                            </Grid>
                            {isEmbedded && embeddedFooter}
                        </div>
                    </GridItem>
                </Grid>
            </ContentContainer>
        </PageContainer>
    );
};
SearchPageContent.displayName = 'SearchPageContent';

export default connect(mapStateToProps, mapDispatchToProps)(SearchPageContent);
